import { Divider, Popover } from "antd";
import { useAppDispatch } from "core/utils";
import type { FC } from "react";
import { useState } from "react";
import styled from "styled-components";

import { useTranslation } from "src/translations";
import { getAssignedDataGroup } from "../../../../../core/router/auth";
import { StorageEvents } from "../../../../../core/router/auth/SecurityManager";
import { useLogoutMutation } from "../../../../../core/router/auth/serverApi";
import { openChangeDataGroup } from "../../../../../core/setup/redux/state/dataGroupModal/dataGroupModalState";
import { Palette, Spaces } from "../../../../../core/styles/theme";
import type { NoneOwnProps } from "../../../../../core/types";
import { PrimaryButton, SecondaryButton } from "../../../../Buttons/components/ActionButton";
import { Icon } from "../../../../Icon";
import { IconCodes } from "../../../../Icon/IconCodes";
import { Language } from "../../../../Language";

/**
 * Displays profile popover with logout and change data group links.
 */
export const ProfilePopover: FC<NoneOwnProps> = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const [currentDataGroup, setCurrentDataGroup] = useState(getAssignedDataGroup());
    const [logout] = useLogoutMutation();

    window.addEventListener(StorageEvents.DATA_GROUP_CHANGED, () => {
        setCurrentDataGroup(getAssignedDataGroup());
    });

    const handleChangeDataGroup = () => {
        dispatch(openChangeDataGroup());
    };

    const handleLogout = async () => {
        await logout({});
    };

    const content = (
        <div>
            <p data-name="current_data_group">
                <StyledIcon iconName={IconCodes.CodeSandboxOutlined} />
                {currentDataGroup?.name}
            </p>
            <SecondaryButton onClick={handleChangeDataGroup} data-name="change_data_group_button">
                {t("button.changeDataGroup")}
            </SecondaryButton>
            <Divider />
            <Language />
            <Divider />
            <PrimaryButton onClick={handleLogout} data-name="logout_button">
                {t("button.logout")}
            </PrimaryButton>
        </div>
    );

    return (
        <Popover content={content} trigger="click">
            <OpenButtonMenu className="aevi-header-usermenu-trigger">&#8942;</OpenButtonMenu>
        </Popover>
    );
};

const StyledIcon = styled(Icon)`
    color: ${Palette.AeviRed};
    padding: ${Spaces.SmallPadding};
`;
const OpenButtonMenu = styled.div`
    color: white;
    font-size: 40px;
    padding: 0 15px;
`;
